/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Failed_TitleInputs */

const en_mcp_connect_failed_title = /** @type {(inputs: Mcp_Connect_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can’t connect`)
};

const es_mcp_connect_failed_title = /** @type {(inputs: Mcp_Connect_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede conectar`)
};

/**
* | output |
* | --- |
* | "Can’t connect" |
*
* @param {Mcp_Connect_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_failed_title = /** @type {((inputs?: Mcp_Connect_Failed_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Failed_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_failed_title(inputs)
	return en_mcp_connect_failed_title(inputs)
});